export const ExceptionErrorCode: { [key: string]: string } = {
  CreateDeliveriesLocationException: "CreateDeliveriesLocationException",
  CreateDeliveriesDuplicatedException: "CreateDeliveriesDuplicatedException",
};
